import { FC, useCallback, useEffect } from "react";
import { useDebounce } from "../../../../../_metronic/helpers";
import axios from 'axios'
import { isBoolean, isEmpty, isNumber, pickBy } from "lodash";

const API_URL = process.env.REACT_APP_API_URL

interface Props {
  appID?: string | number;
  reviewId?: string | number;
  values: Record<string, any>;
  isSubmitting: boolean;
  verdict?: string;
}

const PhaseFormObserver: FC<Props>  = ({appID, reviewId, values, isSubmitting, verdict = ''}) => {

  // 1. Serialize values directly into the debouncer (no local useState needed)
  const currentPayload = isSubmitting || !values
    ? ''
    : JSON.stringify(pickBy({
        ...values,
        verdict: verdict || values?.verdict || '',
      }, (val) => {
        // Always keep booleans and numbers (including 0)
        if (isBoolean(val) || isNumber(val)) return true;

        // For objects, arrays, strings, and null/undefined: check if non-empty
        return !isEmpty(val);
      }));

  const debouncedResponse = useDebounce(currentPayload, 800);
  
  const submitChanges = useCallback( async (draft: string) => {
    const payload = {
      draft,
      ...(appID ? { id: appID } : reviewId ? { reviewId } : {}),
    };

    try {
      await axios.post(`${API_URL}/UpdatePhaseDraftServlet`, payload);
    } catch (err) {
      console.error('Failed to auto-save draft:', err);
    }
  }, [appID, reviewId] );

  // 3. Trigger auto-save only when debounced string updates
  useEffect(() => {
    if (!debouncedResponse) return;

    submitChanges(debouncedResponse);
  }, [debouncedResponse, submitChanges]);

  return null;
};

export { PhaseFormObserver }